"use client";
import { Seedling } from "@icon-park/svg";
import { FC, useState } from "react";
import Button from "../Button";
import Icon from "../Icon";
import { Locale } from "../lib/i18n";
import { offerLabels } from "../lib/labels";
import Popover from "../Popover";

interface SustainableBadgeProps {
  locale: Locale;
}
const SustainableBadge: FC<SustainableBadgeProps> = ({ locale }) => {
  const [showMore, setShowMore] = useState(false);
  const labels = offerLabels[locale];

  return (
    <Popover
      variant="white"
      content={
        <>
          <h4 className="text-app-h3 mb-2xs">
            {labels.sustainableDefinitionTitle}
          </h4>
          <p className="text-app-body-1">
            {labels.sustainableDefinition}
            {showMore ? labels.sustainableDefinitionMore : "..."}
            {!showMore && (
              <Button
                size="md"
                variant="ghost"
                paddingX={false}
                onClick={() => setShowMore(true)}
                iconEnd="Down"
              >
                {labels.readFullDefinition}
              </Button>
            )}
          </p>
        </>
      }
      trigger="hover"
    >
      <span className="text-[#1A9883] ml-2xs w-m h-m rounded-full bg-[#1A9883] bg-opacity-10 flex justify-center items-center cursor-pointer">
        <Icon icon={Seedling} size="20" className="" />
      </span>
    </Popover>
  );
};

export default SustainableBadge;
